import { render, staticRenderFns } from "./HashtagsSetupView.vue?vue&type=template&id=85fdbdd4&scoped=true&"
import script from "./HashtagsSetupView.vue?vue&type=script&lang=ts&"
export * from "./HashtagsSetupView.vue?vue&type=script&lang=ts&"
import style0 from "./HashtagsSetupView.vue?vue&type=style&index=0&id=85fdbdd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85fdbdd4",
  null
  
)

export default component.exports